// src/features/chat/components/his/SemanticDiff.jsx
import React from 'react';
import styles from '../../styles/HisArtifact.module.css';

const DIFF_CHANGE_LABELS = {
  add: 'Add',
  remove: 'Remove',
  delete: 'Clear',
  replace: 'Change',
  set: 'Set',
  soft_delete: 'Delete',
  already_present: 'Already present',
};

function diffLabel(entry) {
  if (entry?.label) return entry.label;
  return String(entry?.path || '').replace(/^content\./, '') || 'Change';
}

function previewText(value) {
  const text = typeof value === 'string' ? value : '';
  return text || '(empty)';
}

function DiffValue({ entry }) {
  const before = previewText(entry.beforePreview);
  const after = previewText(entry.afterPreview);
  const changeKind = entry.changeKind || 'replace';

  if (changeKind === 'add' || changeKind === 'set') {
    return <span className={styles.diffNew}>{after}</span>;
  }
  if (changeKind === 'remove' || changeKind === 'delete' || changeKind === 'soft_delete') {
    return <span className={styles.diffOld}>{before}</span>;
  }
  if (changeKind === 'already_present') {
    return <span className={styles.diffNew}>{after !== '(empty)' ? after : before}</span>;
  }
  return (
    <>
      <span className={styles.diffOld}>{before}</span>
      <span className={styles.diffArrow} aria-hidden="true">→</span>
      <span className={styles.diffNew}>{after}</span>
    </>
  );
}

/**
 * Semantic diff rows for the folded Details of an owner-world update card.
 */
export function SemanticDiff({ rows }) {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  return (
    <div className={styles.diff}>
      {rows.map((entry, index) => (
        <div
          key={`${entry.path || entry.label || 'diff'}:${index}`}
          className={styles.diffRow}
          data-risk={entry.risk || 'normal'}
        >
          <div className={styles.diffLabel}>
            {diffLabel(entry)}
            {' · '}
            {DIFF_CHANGE_LABELS[entry.changeKind] || 'Change'}
          </div>
          <DiffValue entry={entry} />
          {entry.previewTruncated && (
            <span className={styles.diffTruncated}>Preview truncated</span>
          )}
        </div>
      ))}
    </div>
  );
}

export default SemanticDiff;
